export const modules = {
  toolbar: {
    container: '.note-toolbar', // Use a class instead of an ID
  },
}

export const formats = ['bold', 'italic', 'strike', 'size', 'list', 'link', 'header', 'align']

export const sizeOptions = [
  { value: 'small', label: 'Small' },
  { value: 'normal', label: 'Normal' },
  { value: 'large', label: 'Large' },
]

export const backgroundColorOptions = {
  default: {
    bg: 'bg-bg2',
    text: 'text-tertiary',
    border: 'border-st2',
    handleTop: 'bg-bg3',
  },
  blue: {
    bg: 'bg-brand/5',
    text: 'text-brand-text/30',
    border: 'border-brand/20',
    handleTop: 'bg-brand/10',
  },
  green: {
    bg: 'bg-status-success/10',
    text: 'text-status-success/30',
    border: 'border-status-success/20',
    handleTop: 'bg-status-success/20',
  },
  yellow: {
    bg: 'bg-status-warning/10',
    text: 'text-status-warning/40',
    border: 'border-status-warning/20',
    handleTop: 'bg-status-warning/10',
  },
  pink: {
    bg: 'bg-status-danger/10',
    text: 'text-status-danger/30',
    border: 'border-status-danger/20',
    handleTop: 'bg-status-danger/10',
  },
  purple: {
    bg: 'bg-brand/10',
    text: 'text-brand-text/40',
    border: 'border-brand/30',
    handleTop: 'bg-brand/20',
  },
}
